// extracted by mini-css-extract-plugin
export default {"activityGraphs":"ActivityGraphs_activityGraphs__XDr5I"};